import { Fragment, useContext, useState } from 'react';
import ProcessContext from '../../../contexts/process/ProcessContext';
import StatusBarButton from '../../layout/StatusBarButton';
import NumberPad from '../../ui-elements/NumberPad';
import Loading from '../../ui-elements/Loading';
import UIContext from '../../../contexts/ui/UIContext';
import { HELP_DESK_LINK } from '../../../constants/helpDesk';

import { useNavigate } from 'react-router-dom';

const TraySelection = ( forwardTo ) => {
  const { loading } = useContext(UIContext);
  const navigate = useNavigate();
  const { continueProcess, activeProcessId, handleError, isNetworkError, notifyError } = useContext(ProcessContext);

  const [display, setDisplay] = useState({
      prefix: 't',
      value: ''
  }); 

  const proceedToSeedTypeSelection = async () => {
    if (
      parseInt(display.value) >
        parseInt(import.meta.env.VITE_MAX_TRAY_NUMBER) ||
      parseInt(display.value) < 1
    ) {
      notifyError(
        `You tried to enter an invalid tray. Please select a tray between 1 and ${
          import.meta.env.VITE_MAX_TRAY_NUMBER
        }`
      );
      return;
    }
    try {
      await continueProcess(
        activeProcessId,
        `${display.prefix}${display.value}`
      );
      if (forwardTo) {
        navigate(forwardTo);
      }
    } catch (error) {
      console.error(error);
      if (isNetworkError(error)) {
        handleError(error);
      } else {
        handleError(
          error,
          <>
            We have encountered a problem while continuing the Process. Please
            contact the support team {HELP_DESK_LINK}.
          </>
        );
      }
    }
  };

  const setValue = (value) => {
      setDisplay(prev => ({ ...prev, value }))
  }

  return (loading ? 
    <Loading fullScreen /> :
    <Fragment>
      <NumberPad prefix={display.prefix} value={display.value} setValue={setValue} />
      {display.value && (
        <StatusBarButton
          type='inline'
          label='Continue'
          icon='fas fa-chevron-right'
          reversed={true}
          statusSlot={5}
          clickHandler={proceedToSeedTypeSelection}
        />
      )}
    </Fragment>
  );
};

export default TraySelection;
